

























































































































































































































import { Component, Ref } from "vue-property-decorator";
import { Link } from "#/types";
import BaseReportList from "@/components/patient/BaseReportList.vue";
import SearchSelect from "#/components/SearchSelect.vue";
import OfficeSelects from "@/components/common_ibow/OfficeSelects.vue";
import StaffSelect from "@/components/common_ibow/StaffSelect.vue";
import SubmitRecord3List from "@/views/submit/SubmitRecord3List.vue";
import { VisitRecord } from "#/model/visit";
import { Group } from "@/components/master/group/common";
import { VForm, Choice } from "@/types";
import * as appDate from "#/utility/appDate";
import BaseRecord2List, { ListItems } from "@/components/list/baseRecord2List";

interface SearchPatientPart {
  office_ids: number[];
  group_ids: number[];
  group_operator: number;
  keyword: string;
}

interface VisitRecordSubmit extends VisitRecord {
  edit: number; // 編集ボタンをソートできるように
  patient_name: string;
  patient_name_kana: string;
}

@Component({
  components: {
    BaseReportList,
    SearchSelect,
    OfficeSelects,
    StaffSelect,
    SubmitRecord3List
  }
})
export default class SubmitList extends BaseRecord2List {
  @Ref("form") private readonly form!: VForm;

  @Ref("reportList") private readonly reportList?: BaseReportList;

  @Ref("record3List") private readonly record3List?: SubmitRecord3List;

  /** 上位タブ 0:看護記録Ⅱ 1:看護記録Ⅲ */
  private viewTab = 0;

  /** 包括型訪問看護療養費フラグ */
  private medicalComprehensiveFlg = 0;

  /** サイドバーリンク（看護記録Ⅱ / 看護記録Ⅲ） */
  private get sidebarLinks(): Link[] {
    return [
      { text: "看護記録Ⅱ", key: "record2" },
      {
        text: "看護記録Ⅲ",
        key: "record3",
        disabled: this.medicalComprehensiveFlg !== 1
      }
    ];
  }

  /** 現在有効なサイドバー項目 */
  private get activeLink(): Link {
    return this.sidebarLinks[this.viewTab];
  }

  private headers = [
    {
      text: "利用者",
      value: "patient_name_sort",
      width: "170px"
    },
    {
      text: "訪問者",
      value: "visit_staff_name",
      width: "150px"
    },
    {
      text: "訪問日時",
      value: "visit_date_time",
      width: "230px"
    },
    {
      text: "記入者",
      value: "create_staff_name",
      width: "150px"
    }
  ];

  private commentHeader = {
    text: "コメント",
    value: "remand_comment"
  };

  private submitHeaders = [
    {
      text: "提出日",
      value: "submit_date_time",
      width: "230px"
    }
  ];

  /** 検索パネルを開いているか */
  private isOpenSearchPanel = false;

  /** グループ選択肢 */
  private groups: Group[] = [];

  /** 職員選択肢 */
  private staffs: Choice[] = [];

  /** 検索条件：訪問職員 */
  private searchStaffId = 0;

  /** 検索条件：編集職員 */
  private searchSubmitStaffId = 0;

  /** 最後に検索したタブ */
  private searchedTab = 0;

  /** 訪問日検索期間：開始月 */
  private searchStartMonth = "";

  /** 訪問日検索期間：終了月 */
  private searchEndMonth = "";

  /** 訪問月（看護記録Ⅲ用） */
  private searchRecord3Month = "";

  /** グループ検索条件のAND/ORとチェックボックスを合わせる */
  private get searchGroupOperator(): boolean {
    return !this.searchCond.group_operator;
  }
  private set searchGroupOperator(newCond: boolean) {
    this.searchCond.group_operator = Number(!newCond);
  }

  /** デフォルト検索条件 */
  private DefaultSearchCond = (): SearchPatientPart => ({
    office_ids: [],
    group_ids: new Array(5).fill(0),
    group_operator: 1,
    keyword: ""
  });
  /** 検索条件 */
  private searchCond = this.DefaultSearchCond();
  /** 検索条件をリセット */
  private resetSearchCond() {
    const defaultCond = this.DefaultSearchCond();
    if (this.DefaultOffices) {
      defaultCond.office_ids = this.DefaultOffices;
    }
    this.searchCond = defaultCond;
    this.searchStartMonth = this.dateToStr(new Date(), "yyyy-MM");
    this.searchEndMonth = this.dateToStr(new Date(), "yyyy-MM");
    this.searchRecord3Month = this.dateToStr(new Date(), "yyyy-MM");

    this.searchStaffId = 0;

    // 提出済みの場合
    if (this.searchedTab === 1) {
      this.searchSubmitStaffId = 0;
    }
  }
  /** デフォルト検索条件：事業所 */
  private get DefaultOffices(): number[] | undefined {
    if (this.loginUser.office_id !== 0) {
      // 所属している場合はログインユーザーの所属事業所
      return [this.loginUser.office_id];
    } else if (this.HeadOffice !== 0) {
      // 所属していない場合は先頭の事業所
      return [this.HeadOffice];
    }
    return undefined;
  }

  // 絞り込みしているかどうか
  private get IsFiltered(): boolean {
    if (this.viewTab === 1) {
      // 看護記録Ⅲ
      return !(
        JSON.stringify(this.searchCond.office_ids) ===
          JSON.stringify(this.DefaultOffices) &&
        !this.searchCond.group_ids.find(id => id !== 0 && id !== null) &&
        this.searchCond.group_operator === 1 &&
        !this.searchCond.keyword &&
        this.searchRecord3Month === this.dateToStr(new Date(), "yyyy-MM") &&
        !this.searchStaffId &&
        !this.searchSubmitStaffId
      );
    } else {
      // 看護記録Ⅱ
      // 未提出
      if (this.searchedTab === 0) {
        return !(
          JSON.stringify(this.searchCond.office_ids) ===
            JSON.stringify(this.DefaultOffices) &&
          !this.searchCond.group_ids.find(id => id !== 0 && id !== null) &&
          this.searchCond.group_operator === 1 &&
          !this.searchCond.keyword &&
          !this.searchStaffId
        );
      } else {
        // 提出済
        return !(
          JSON.stringify(this.searchCond.office_ids) ===
            JSON.stringify(this.DefaultOffices) &&
          !this.searchCond.group_ids.find(id => id !== 0 && id !== null) &&
          this.searchCond.group_operator === 1 &&
          !this.searchCond.keyword &&
          this.searchStartMonth === this.dateToStr(new Date(), "yyyy-MM") &&
          this.searchEndMonth === this.dateToStr(new Date(), "yyyy-MM") &&
          !this.searchStaffId &&
          !this.searchSubmitStaffId
        );
      }
    }
  }

  created() {
    // デフォルトの検索事業所を設定
    if (this.searchCond.office_ids.length === 0 && this.DefaultOffices) {
      this.searchCond.office_ids = this.DefaultOffices;
    }
    this.searchStartMonth = this.dateToStr(new Date(), "yyyy-MM");
    this.searchEndMonth = this.dateToStr(new Date(), "yyyy-MM");
    this.searchRecord3Month = this.dateToStr(new Date(), "yyyy-MM");

    this.fetchGroups();
    // 包括型フラグを取得し、?view=3 クエリに応じてタブ初期化・一覧取得を行う
    this.fetchMedicalComprehensiveFlg();
  }

  /** 包括型フラグを取得（看護記録Ⅲタブの活性制御・初期タブ決定に使用） */
  private fetchMedicalComprehensiveFlg(): void {
    this.postJsonCheck(
      window.base_url + "/api/patient/visitrecord3s/medicalComprehensiveFlg",
      {},
      res => {
        this.medicalComprehensiveFlg = res.data.medical_comprehensive_flg ?? 0;
        // ?view=3 かつフラグONの場合は看護記録Ⅲタブを初期表示
        if (
          this.$route.query.view === "3" &&
          this.medicalComprehensiveFlg === 1
        ) {
          this.viewTab = 1;
          this.$nextTick(() => this.fetchRecord3Search());
          return;
        }
        // 未提出タブ以外ではタブ変更後の取得処理に任せる
        if (
          !this.$route.query.reporttab ||
          this.$route.query.reporttab === "0"
        ) {
          this.fetchRecord2({ tab: 0, page: 0 });
        }
      }
    );
  }

  /** サイドバークリック（看護記録Ⅱ ⇔ 看護記録Ⅲ） */
  private onSideBarClick({ index }: { link: Link; index: number }): void {
    this.viewTab = index;
    // 記録書Ⅱタブ選択時のみ記録書Ⅱ一覧を取得
    if (index === 0 && this.records.length === 0) {
      this.fetchRecord2({ tab: this.searchedTab, page: 0 });
    }
    const nextView = index === 1 ? "3" : "2";
    if (this.$route.query.view !== nextView) {
      this.$router.replace({ query: { ...this.$route.query, view: nextView } });
    }

    if (this.viewTab == 1) {
      // 看護記録Ⅲ
      this.$nextTick(() => this.fetchRecord3Search());
    } else {
      // 看護記録Ⅱ
      this.reportList?.resetLoaded();
      this.fetchRecord2({ tab: this.searchedTab, page: 0 });
    }
  }

  /** 看護記録Ⅲ一覧を取得 */
  private fetchRecord3Search(): void {
    this.record3List?.search({
      part: {
        office_ids: this.searchCond.office_ids,
        group_ids: this.searchCond.group_ids.filter(Boolean),
        group_operator: this.searchCond.group_operator,
        keyword: this.searchCond.keyword
      },
      start_month: this.searchRecord3Month,
      end_month: this.searchRecord3Month
    });
  }

  /** SubmitRecord3List のインライン検索ボタン押下 */
  private onRecord3ClickSearch(keyword: string): void {
    this.searchCond.keyword = keyword;
    this.fetchRecord3Search();
  }

  /** SubmitRecord3List からの包括型フラグ更新 */
  private onUpdateMedicalComprehensiveFlg(flg: number): void {
    this.medicalComprehensiveFlg = flg;
  }

  /** グループリスト取得 */
  private fetchGroups() {
    this.postJsonCheck(window.base_url + "/api/master/groups/get", {}, res => {
      this.groups = res.data.groups;
    });
  }

  /** タブが切り替わった時 */
  private updateTab(obj: { tab: number; page: number }) {
    this.searchedTab = obj.tab;
    this.fetchRecord2(obj);
  }

  // 一覧取得
  private fetchRecord2(obj: { tab: number; page: number }) {
    // 提出済みタブのみ、月での絞り込みをする
    const searchStartMonth = obj.tab === 1 ? this.searchStartMonth : "";
    const searchEndMonth = obj.tab === 1 ? this.searchEndMonth : "";
    const searchStaffId = this.searchStaffId ? [this.searchStaffId] : [];
    const searchSubmitStaffId =
      this.searchSubmitStaffId && obj.tab === 1
        ? [this.searchSubmitStaffId]
        : [];
    this.postJsonCheck(
      window.base_url + "/api/patient/visitrecords/search",
      {
        part: {
          ...this.searchCond,
          group_ids: this.searchCond.group_ids.filter(Boolean)
        },
        tab: obj.tab,
        staff_ids: searchStaffId,
        editor_staff_ids: searchSubmitStaffId,
        start_month: searchStartMonth,
        end_month: searchEndMonth,
        page: obj.page
      },
      res => {
        if (res.data.records != null) {
          this.reportList?.finishLoaded(res.data.records);
          if (obj.page != 0) {
            this.records = this.records.concat(res.data.records);
          } else {
            this.records = res.data.records;
          }
        } else {
          this.reportList?.finishLoaded([]);
        }
        if (res.data.staffs != null) {
          this.staffs = res.data.staffs;
        }
      }
    );
  }

  /** 検索条件バリデーション：看護記録Ⅲ訪問月 */
  private checkRecord3Month(): boolean | string {
    if (!this.searchRecord3Month) {
      return "訪問月を入力すると検索できます";
    }
    if (Number.isNaN(appDate.strToDateObj(this.searchRecord3Month).getDate())) {
      return "訪問月の入力形式に誤りがあります";
    }
    return true;
  }

  /** 検索条件バリデーション：事業所選択 */
  private checkOfficeSelect(): boolean | string {
    //1つも選択していない場合
    if (!this.searchCond.office_ids || this.searchCond.office_ids.length == 0) {
      return "1事業所は選択してください";
    }
    //5つ以上選択している場合
    if (!this.searchCond.office_ids || this.searchCond.office_ids.length > 5) {
      return "最大5事業所まで選択可能です";
    }
    return true;
  }

  /** 検索条件バリデーション：期間の開始月 */
  private checkStartMonth(
    startMonthStr: string,
    endMonthStr: string
  ): boolean | string {
    const startMonth = appDate.strToDateObj(startMonthStr);
    const endMonth = appDate.strToDateObj(endMonthStr);

    // 開始月が入力されていない場合
    if (!startMonthStr) {
      return "開始月を入力すると検索できます";
    }
    // 有効な開始月として解釈できない場合
    if (Number.isNaN(startMonth.getDate())) {
      return "開始月の入力形式に誤りがあります";
    }
    // 開始月が終了月よりも後である場合
    if (startMonth > endMonth) {
      return "開始月は終了月よりも前に設定してください";
    }
    return true;
  }

  /** 検索条件バリデーション：期間の終了月 */
  private checkEndMonth(
    startMonthStr: string,
    endMonthStr: string
  ): boolean | string {
    const startMonth = appDate.strToDateObj(startMonthStr);
    const endMonth = appDate.strToDateObj(endMonthStr);
    // 終了月が入力されていない場合
    if (!endMonthStr) {
      return "終了月を入力すると検索できます";
    }
    // 有効な終了月として解釈できない場合
    if (Number.isNaN(endMonth.getDate())) {
      return "終了月の入力形式に誤りがあります";
    }
    // 終了月が開始月よりも前である場合
    if (startMonth > endMonth) {
      return "終了月は開始月よりも後に設定してください";
    }
    return true;
  }

  /**
   * 検索ボタン押下
   */
  private async clickSearch() {
    if (!this.form.validate()) {
      await this.$openAlert("入力内容に不備があります");
      return;
    }
    if (this.viewTab === 1) {
      // 看護記録Ⅲ検索
      this.fetchRecord3Search();
    } else {
      // 看護記録Ⅱ検索
      this.reportList?.resetLoaded();
      this.fetchRecord2({ tab: this.searchedTab, page: 0 });
    }
  }

  // 差し戻し
  private async clickRemand(item: ListItems) {
    if (await this.remand(item)) {
      this.reportList?.clickRemandBtn(item);
    }
  }
}
